/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opening_InquiryInputs */

const en_opening_inquiry = /** @type {(inputs: Opening_InquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening inquiry…`)
};

const es_opening_inquiry = /** @type {(inputs: Opening_InquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abriendo consulta…`)
};

const fr_opening_inquiry = /** @type {(inputs: Opening_InquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouverture de la demande…`)
};

const de_opening_inquiry = /** @type {(inputs: Opening_InquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anfrage wird geöffnet…`)
};

const ja_opening_inquiry = /** @type {(inputs: Opening_InquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`問い合わせを開いています…`)
};

const zh_opening_inquiry = /** @type {(inputs: Opening_InquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在打开咨询窗口…`)
};

const ar_opening_inquiry = /** @type {(inputs: Opening_InquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جاري فتح الاستفسار…`)
};

const id_opening_inquiry = /** @type {(inputs: Opening_InquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membuka pertanyaan…`)
};

const it_opening_inquiry = /** @type {(inputs: Opening_InquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apertura richiesta in corso…`)
};

const ru_opening_inquiry = /** @type {(inputs: Opening_InquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открытие запроса…`)
};

const pt_opening_inquiry = /** @type {(inputs: Opening_InquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrindo consulta…`)
};

const ko_opening_inquiry = /** @type {(inputs: Opening_InquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문의 창을 여는 중…`)
};

/**
* | output |
* | --- |
* | "Opening inquiry…" |
*
* @param {Opening_InquiryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const opening_inquiry = /** @type {((inputs?: Opening_InquiryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opening_InquiryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opening_inquiry(inputs)
	if (locale === "es") return es_opening_inquiry(inputs)
	if (locale === "fr") return fr_opening_inquiry(inputs)
	if (locale === "de") return de_opening_inquiry(inputs)
	if (locale === "ja") return ja_opening_inquiry(inputs)
	if (locale === "zh") return zh_opening_inquiry(inputs)
	if (locale === "ar") return ar_opening_inquiry(inputs)
	if (locale === "id") return id_opening_inquiry(inputs)
	if (locale === "it") return it_opening_inquiry(inputs)
	if (locale === "ru") return ru_opening_inquiry(inputs)
	if (locale === "pt") return pt_opening_inquiry(inputs)
	return ko_opening_inquiry(inputs)
});